import React, { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { getAccountClientDepartmentByAccountPartyIdAndAccountClientDepartmentIdAsync, deleteAccountClientDepartmentAsync, 
    checkedState, unCheckedState, checkedAllState, unCheckedAllState } from "./ClientDepartmentSlice";
import { useAppDispatch } from "../../../app/hooks";
import { ShowSwalWithConfirmation } from '../../../common/SweetAlert';
import CustomPagination from "../../../common/Pagination";
import { KTIcon } from '../../../_metronic/helpers';
import { ShowToast } from '../../../common/Toastr';

export const ClientDepartmentItem = (props: any) => {

    const { clientDepartmentList,AccountPartyId } = props;
    const dispatch = useAppDispatch();

    const [pageSize, setPageSize] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');

    const handlePageChange = (pageNumber: any) => {
        setCurrentPage(pageNumber);
    };
    const handleSearch = (event: any) => {
        const { value } = event.target;
        setSearchTerm(value);
        setCurrentPage(1); // Reset to the first page when searching
    };
    const handlePageSizeChange = (event: any) => {
        const { value } = event.target;
        setPageSize(Number(value));
        setCurrentPage(1); // Reset to the first page when changing itemsPerPage
    };

    
     // Filtering and pagination logic
   const filteredData = clientDepartmentList.filter((item: any) => {
    const searchTermLowerCase = searchTerm.toLowerCase();
    return Object.values(item).some((value: any) => {
        if (typeof value === 'string') {
            return value.toLowerCase().includes(searchTermLowerCase);
        }
        return false;
    });
});

    const indexOfLastItem = currentPage * pageSize;
    const indexOfFirstItem = indexOfLastItem - pageSize;
    const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
    const totalItems = clientDepartmentList.length;
    //console.log('length', totalItems, currentItems.length, filteredData);
    const recordsFiltered = (totalItems === filteredData.length ? 0 : currentItems.length);

    const handleCheckboxChange = (e: any, rowId: any) => {
        if (e.target.checked) {
            dispatch(checkedState(rowId))
        } else {
            dispatch(unCheckedState(rowId))
        }
    };
    const handleSelectAllChange = (e: any) => {
        const { checked } = e.target;
        if (checked) {
            dispatch(checkedAllState());
        } else {
            dispatch(unCheckedAllState());
        }
    };
    const onEditClick = (AccountPartyDepartmentId: number) => {
        dispatch(getAccountClientDepartmentByAccountPartyIdAndAccountClientDepartmentIdAsync(AccountPartyDepartmentId))
            .unwrap()
            .then((originalPromiseResult) => {
                //modelRef.current.click();

            })
            .catch((rejectedValueOrSerializedError) => {
                console.log('getAccountEmployeeTypeByAccountEmployeeTypeIdAsync-rejectedValueOrSerializedError', rejectedValueOrSerializedError);
            })
    }
    const onDeleteClick = (AccountPartyDepartmentId: string) => {
        ShowSwalWithConfirmation('Are you sure you want to delete this record?', "")
            .then((result) => {
                if (result) {
                    dispatch(deleteAccountClientDepartmentAsync(AccountPartyDepartmentId))
                        .unwrap()
                        .then((originalPromiseResult) => {
                            originalPromiseResult.StatusCode === "200" ?
                            ShowToast("Client Department delete Successfully", 'Success', "success", "toast-top-right") :
                            ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                            //console.log('onDeleteClick-deleteAccountEmployeeTypeAsync-originalPromiseResult', originalPromiseResult);
                        })
                        .catch((rejectedValueOrSerializedError) => {
                            ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
                            //console.log('onDeleteClick-deleteAccountEmployeeTypeAsync-rejectedValueOrSerializedError', rejectedValueOrSerializedError);
                        })
                }
            })
            .catch((error) => {
                console.log("ShowSwalWithConfirmation:error ", error);
            });
    }

    return (
        <>

            <div className='row' >
                <div className='col-md-6'>
                    <div className="d-flex align-items-center position-relative my-1">
                        <i className="ki-duotone ki-magnifier fs-1 position-absolute ms-6">
                            <span className="path1"></span>
                            <span className="path2"></span>
                        </i>
                        <input
                            type="text"
                            value={searchTerm}
                            onChange={handleSearch}
                            placeholder="Search"
                            className='form-control form-control-solid w-250px ps-14'
                            data-kt-user-table-filter="search"
                        />

                    </div>
                </div>
                <div className='col-md-6'>
                    <div className="dataTables_length float-end" id="kt_datatable_zero_configuration_length">
                        <label>
                            <select name="kt_datatable_zero_configuration_length" aria-controls="kt_datatable_zero_configuration"
                                className="form-select form-select form-select-solid"
                                value={pageSize} onChange={handlePageSizeChange}
                            >
                                <option value="10">10</option>
                                <option value="20">20</option>
                                <option value="30">30</option>
                                <option value="40">40</option>
                                <option value="50">50</option>
                                {/* <option value="All">All</option> */}
                            </select>
                        </label>
                    </div>
                </div>

            </div>


            <table className="table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4" >
                <thead>
                    <tr className="fw-bold text-muted">
                        <th className='w-25px'>
                            <div className='form-check form-check-sm form-check-custom form-check-solid'>
                                <input
                                    className='form-check-input'
                                    type='checkbox'
                                    checked={clientDepartmentList.every((item: any) => item.isSelected === 0) ? false :
                                        (clientDepartmentList.every((item: any) => item.isSelected === 1 ? true : false))
                                    }
                                    onChange={handleSelectAllChange}
                                />
                            </div>
                        </th>
                        <th className='min-w-100%'>DEPARTMENT CODE</th>
                        <th className='min-w-100%'>DEPARTMENT NAME</th>
                        <th className='min-w-100%'>DEPARTMENT LOCATION</th>
                        <th className='min-w-100% text-end '>ACTIONS</th>
                    </tr>
                </thead>
                <tbody>
                    {currentItems.length === 0 && <tr><td>No Record Found.</td></tr>}
                    {currentItems.length > 0 && currentItems.map((clientDepartmentDetail: any, i: any) => (
                        <tr key={i}>
                            <td>
                                <div className='form-check form-check-sm form-check-custom form-check-solid'>
                                    <input
                                        type="checkbox"
                                        className="form-check-input widget-9-check"
                                        checked={clientDepartmentDetail.isSelected == 0 ? false : true}
                                        onChange={(e) => { handleCheckboxChange(e, clientDepartmentDetail.AccountPartyDepartmentId) }}
                                    />
                                </div>
                            </td>
                            <td>
                                <a id="kt_OffCanvas"
                                    className='text-gray-800 fw-normal text-hover-primary d-block  fw-bold'
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => { onEditClick(clientDepartmentDetail.AccountPartyDepartmentId) }}>
                                    {clientDepartmentDetail.PartyDepartmentCode}
                                </a>
                            </td>
                            <td><span className="text-muted fw-semibold text-muted d-block fs-7">{clientDepartmentDetail.PartyDepartmentName}</span></td>
                            <td><span className="text-muted fw-semibold text-muted d-block fs-7">{clientDepartmentDetail.PartyDepartmentLocation}</span></td>
                            <td className='text-end'>
                                <div className='d-flex justify-content-end flex-shrink-0'>
                                    <a id="kt_OffCanvas" className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                        onClick={() => { onEditClick(clientDepartmentDetail.AccountPartyDepartmentId) }}>
                                        <KTIcon iconName='pencil' className='fs-3' />
                                    </a>
                                    <a className='btn btn-icon btn-bg-light btn-active-color-danger btn-sm'
                                        onClick={() => { onDeleteClick(clientDepartmentDetail.AccountPartyDepartmentId) }}>
                                        <KTIcon iconName='trash' className='fs-3' />
                                    </a>
                                </div>
                            </td>
                        </tr>
                    ))}

                </tbody>
            </table >
            <div>
                {(currentItems.length > 0) ? (
                    <CustomPagination
                        currentPage={currentPage}
                        onPageChange={handlePageChange}
                        pageSize={pageSize}
                        totalItems={totalItems}
                        start={(currentPage - 1) * pageSize}

                    >

                    </CustomPagination>
                ) : null}
            </div>
        </>
    )
}
